// Head verbs, DERIVED by scripts/harvest-head-verbs.py. Do not hand-edit: regenerate.
// The same lexicon worker/head-verbs.txt carries, so the page and the voiceover frame a
// beat the same way. scripts/harvest-head-verbs.py --check fails when they disagree.
export const HEAD_VERBS = new Set([
  'accept',
  'address',
  'admit',
  'agree',
  'aim',
  'announce',
  'answer',
  'appear',
  'arrive',
  'ask',
  'balance',
  'bar',
  'beat',
  'begin',
  'bend',
  'bind',
  'bite',
  'block',
  'bob',
  'bolt',
  'bow',
  'bowl',
  'brace',
  'break',
  'bring',
  'brush',
  'bu',
  'burn',
  'burst',
  'button',
  'call',
  'campu',
  'cap',
  'carry',
  'catch',
  'chalk',
  'check',
  'circle',
  'clamp',
  'clap',
  'claw',
  'click',
  'climb',
  'clip',
  'close',
  'coach',
  'coil',
  'come',
  'copy',
  'correct',
  'count',
  'crack',
  'cradle',
  'crank',
  'crawl',
  'cross',
  'crouch',
  'crush',
  'cup',
  'curl',
  'cut',
  'decide',
  'descend',
  'dial',
  'die',
  'dig',
  'dip',
  'dive',
  'do',
  'draft',
  'drag',
  'drape',
  'draw',
  'drift',
  'drill',
  'drink',
  'drive',
  'drop',
  'duck',
  'eat',
  'empty',
  'enter',
  'fall',
  'fasten',
  'feed',
  'fight',
  'file',
  'fill',
  'find',
  'finish',
  'fit',
  'flatten',
  'flex',
  'flick',
  'flicker',
  'flinch',
  'flip',
  'float',
  'flood',
  'flop',
  'fold',
  'freeze',
  'gather',
  'get',
  'give',
  'go',
  'grab',
  'grind',
  'grip',
  'halt',
  'hammer',
  'hand',
  'hang',
  'haul',
  'have',
  'heave',
  'hit',
  'hold',
  'hook',
  'hop',
  'hover',
  'hurl',
  'intercept',
  'jab',
  'jam',
  'jump',
  'keep',
  'key',
  'kick',
  'kill',
  'kneel',
  'knock',
  'knot',
  'ladle',
  'land',
  'lash',
  'laugh',
  'lay',
  'lead',
  'lean',
  'leave',
  'let',
  'lever',
  'lie',
  'lift',
  'light',
  'line',
  'listen',
  'lock',
  'look',
  'loop',
  'lope',
  'lower',
  'lunge',
  'make',
  'mark',
  'measure',
  'meet',
  'move',
  'nail',
  'name',
  'national',
  'nudge',
  'offer',
  'open',
  'pace',
  'pack',
  'paint',
  'pane',
  'paste',
  'pause',
  'pay',
  'peel',
  'photograph',
  'pick',
  'pin',
  'place',
  'plant',
  'play',
  'plug',
  'plunge',
  'pocket',
  'point',
  'polish',
  'post',
  'pour',
  'press',
  'print',
  'prop',
  'pry',
  'pull',
  'punch',
  'push',
  'put',
  'raise',
  'rake',
  'reach',
  'read',
  'record',
  'refuse',
  'release',
  'rest',
  'retire',
  'rewrite',
  'ride',
  'ring',
  'rinse',
  'rip',
  'rise',
  'rock',
  'roll',
  'round',
  'rule',
  'run',
  'sag',
  'say',
  'scoop',
  'scrape',
  'scratch',
  'screw',
  'scroll',
  'scrub',
  'seal',
  'seat',
  'see',
  'send',
  'set',
  'settle',
  'shake',
  'sheet',
  'shelve',
  'shield',
  'shoulder',
  'shove',
  'shovel',
  'show',
  'shuffle',
  'shut',
  'sign',
  'sing',
  'sink',
  'sit',
  'skid',
  'slam',
  'slap',
  'sleep',
  'slide',
  'slip',
  'slit',
  'slump',
  'smooth',
  'snap',
  'snatch',
  'snuff',
  'sort',
  'speak',
  'spill',
  'spin',
  'spit',
  'split',
  'spread',
  'sprint',
  'square',
  'squeeze',
  'stack',
  'stagger',
  'stamp',
  'stand',
  'stare',
  'start',
  'stay',
  'steady',
  'steer',
  'step',
  'stir',
  'stitch',
  'stop',
  'straighten',
  'strap',
  'strike',
  'strip',
  'stumble',
  'surface',
  'sweep',
  'swim',
  'swing',
  'swipe',
  'switch',
  'take',
  'talk',
  'tap',
  'tape',
  'taste',
  'teach',
  'tear',
  'tell',
  'thread',
  'throw',
  'thumb',
  'tie',
  'tighten',
  'tilt',
  'tip',
  'toss',
  'touch',
  'trace',
  'train',
  'trot',
  'try',
  'tuck',
  'tug',
  'turn',
  'twist',
  'type',
  'unbuckle',
  'unclip',
  'unfold',
  'unhook',
  'unlock',
  'unpin',
  'unplug',
  'unroll',
  'unty',
  'unwind',
  'unwrap',
  'vault',
  'wade',
  'wait',
  'wake',
  'walk',
  'wall',
  'watch',
  'wedge',
  'wheel',
  'wind',
  'wipe',
  'work',
  'wrap',
  'wrench',
  'wring',
  'write',
  'yank',
]);
